import React from 'react';

type Props = {
  width?: number | string;
  height?: number | string;
};

export const Separator = (props: Props) => <div style={{ ...props }} />;
